import { useEffect, useState, useRef } from "react";
import { Box, Grid } from "@mui/material";
import styled from "styled-components";
import html2canvas from "html2canvas";

const Timestamp = styled(Box)`
  width: 100%;
  height: 200px;
  position: relative;
  .timetamp {
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #28282850;
    font-family: monospace;
    font-size: 12px;
  }
`;

export default function ({
  setStampedCustomerSignature = () => null,
  setStampedMemberSignature = () => null,
  stampedCustomerSignature,
  stampedMemberSignature,
  customerSignature,
  memberSignature,
  ip,
}) {
  const refCustomerSignature = useRef();
  const refMemberSignature = useRef();

  // ? Este modal es solo visual, esta ubicado debajo del modal original
  // ? esto para que se pueda convertir html en canvas para agreagar la
  // ? marca de agua en la firma

  useEffect(() => {
    if (customerSignature) {
      exportAsImage(refCustomerSignature.current, setStampedCustomerSignature);
    } else {
      setStampedCustomerSignature(null);
    }
  }, [customerSignature, stampedCustomerSignature]);

  useEffect(() => {
    if (memberSignature) {
      exportAsImage(refMemberSignature.current, setStampedMemberSignature);
    } else {
      setStampedMemberSignature(null);
    }
  }, [memberSignature, stampedMemberSignature]);

  const exportAsImage = async (element, setStamp) => {
    const canvas = await html2canvas(element);
    const stamped = canvas.toDataURL("image/png");
    setStamp(stamped);
  };

  return (
    <Grid container>
      {customerSignature && (
        <Grid item xs={12}>
          <Timestamp
            mb={4}
            display={"flex"}
            justifyContent={"center"}
            ref={refCustomerSignature}
          >
            <Box className={"timetamp"}>
              {`IP: ${ip}`}
              <br />
              {`TIME: ${new Date()}`}
              <br />
              {window.navigator.userAgent}
            </Box>
            <img
              style={{ width: "100%", height: "100%" }}
              src={customerSignature}
            />
          </Timestamp>
        </Grid>
      )}

      {memberSignature && (
        <Grid item xs={12}>
          {/* Member stamp */}
          <Timestamp
            mb={4}
            display={"flex"}
            justifyContent={"center"}
            ref={refMemberSignature}
          >
            <Box className={"timetamp"}>
              {`IP: ${ip}`}
              <br />
              {`TIME: ${new Date()}`}
              <br />
              {window.navigator.userAgent}
            </Box>
            <img
              style={{ width: "100%", height: "100%" }}
              src={memberSignature}
            />
          </Timestamp>
        </Grid>
      )}
    </Grid>
  );
}
